export const AutoTextUUIDs = {
  LOvaryComments: 'd69ea343-5b44-4528-b327-f232a23e648d',
  ROvaryComments: '644ca5fe-6608-4afd-b1ce-cb03dcd51e86',
  LFTubeComments: 'b302d9d7-7523-4451-90a9-faf7a537b0a6',
  RFTubeComments: '95976d93-03b8-4748-8e74-0e361f1a55ac',
  LDopplerComments: '546098c7-a51a-4b6f-824e-6ff7b93249f1',
  RDopplerComments: '89295ef7-f893-42c1-8ccd-2b1c6e989daf',
};
